import compose from "lodash/flowRight"
import PropTypes from "prop-types"
import React, { Component, useContext } from "react"
import withCreatePathItem from "../graphql/withCreatePathItem"
import withDeletePathItem from "../graphql/withDeletePathItem"
import withPathItems from "../graphql/withPathItems"
import withReorderPathItems from "../graphql/withReorderPathItems"
// import { withCohortSyncPlanContext } from "../sync/SyncPlanContext"
import { handlePathItemDragEnd } from "../utils"
import EditPathList from "./EditPathList"

export const EditPathContext = React.createContext()

export const useEditPathContext = () => useContext(EditPathContext)

class EditPath extends Component {
  state = {
    editingId: null, // Path item id where user is actively editing a path item
    archivingId: null, // Path item id where user is actively archiving a path item
    addingAtIndex: null // Index where user is actively adding a path item
  }

  setEditingId = (pathItemId) => {
    // Prepare path item for editing
    this.setState({
      editingId: pathItemId,
      archivingId: null,
      addingAtIndex: null
    })
  }

  setArchivingId = (pathItemId) => {
    // Prepare path item for archiving
    this.setState({
      editingId: null,
      archivingId: pathItemId,
      addingAtIndex: null
    })
  }

  setAddingAtIndex = (pathIndex) => {
    // Expand path add editor at index
    this.setState({
      editingId: null,
      addingAtIndex: pathIndex,
      archivingId: null
    })
  }

  clearEditingState = () => {
    // Collapse any open path add editors
    // Hide any path item archive overlays
    this.setState({ editingId: null, addingAtIndex: null, archivingId: null })
  }

  handleDragStart = () => {
    this.clearEditingState()
  }

  handleDragEnd = (result) => {
    const pathItems = handlePathItemDragEnd(result, this.props.items)
    // reorder path items based on new pathItems structure
    this.props.reorderPathItems(pathItems)
  }

  handleChange = () => {
    // HACK: Apollo bug? This does refetch the sync plan queries but DOES NOT cause the SyncButton to update
    // unclear as to why, but the query data in the SyncButton is stale
    // Maybe related: https://github.com/apollographql/apollo-client/issues/3909
    // appears that below works because the useSyncPlanContext is higher up in the tree, above the SyncButton
    // this.props.refetchSyncPlanQueries()
    window.App &&
      window.App.getStore("pathAdmin").storeTrigger("path:item:updated")
  }

  render() {
    return (
      <EditPathContext.Provider
        value={{
          // state
          pathItems: this.props.items,
          editingId: this.state.editingId,
          archivingId: this.state.archivingId,
          addingAtIndex: this.state.addingAtIndex,
          // actions
          setEditingId: this.setEditingId,
          setArchivingId: this.setArchivingId,
          setAddingAtIndex: this.setAddingAtIndex,
          clearEditingState: this.clearEditingState,
          createPathItem: this.props.createPathItem,
          deletePathItem: this.props.deletePathItem,
          handleChange: this.handleChange
        }}
      >
        <EditPathList
          {...this.props}
          onDragStart={this.handleDragStart}
          onDragEnd={this.handleDragEnd}
        />
      </EditPathContext.Provider>
    )
  }
}

EditPath.displayName = "EditPath"

EditPath.propTypes = {
  id: PropTypes.number,
  cohort_id: PropTypes.number
}

export default compose(
  withPathItems,
  withReorderPathItems,
  withCreatePathItem,
  withDeletePathItem,
  // withCohortSyncPlanContext
)(EditPath)
